// Which seasonal theme is active, from the visitor's clock. Plain, self-contained JS on purpose:
// the site is statically generated, so the date can't be checked at build time. This source is
// inlined into <head> as-is (see app.vue) to set data-season before first paint, and the app
// imports the same function to show the greeting and effects.
//
// config: app.config.ts `season`. search: location.search, for the ?season= preview.
// Returns { name: 'gregorian' | 'hijri', year } or null.
export function resolveSeason(now, config, search) {
  function dateParts(calendar) {
    var parts = new Intl.DateTimeFormat('en-u-ca-' + calendar + '-nu-latn', {
      timeZone: config.timeZone,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    }).formatToParts(now)
    var get = function (type) {
      for (var i = 0; i < parts.length; i++) if (parts[i].type === type) return Number(parts[i].value)
    }
    return { year: get('year'), month: get('month'), day: get('day') }
  }
  // '12-26' -> 1226, so month-day pairs compare as plain numbers.
  function monthDay(md) {
    var p = md.split('-')
    return Number(p[0]) * 100 + Number(p[1])
  }
  function inWindow(name) {
    if (name === 'gregorian') {
      var g = dateParts('gregory')
      var today = g.month * 100 + g.day
      var from = monthDay(config.gregorian.from)
      var to = monthDay(config.gregorian.to)
      var on = from <= to ? today >= from && today <= to : today >= from || today <= to
      // Before Jan 1 the greeting is already for the coming year.
      return on ? { name: name, year: g.month === 12 ? g.year + 1 : g.year } : null
    }
    var h = dateParts('islamic-umalqura')
    return h.month === 1 && h.day <= config.hijri.days ? { name: name, year: h.year } : null
  }
  // A pinned season outside its window greets the year that comes next.
  function pinned(name) {
    return inWindow(name) || { name: name, year: dateParts(name === 'hijri' ? 'islamic-umalqura' : 'gregory').year + 1 }
  }

  var preview = /[?&]season=(gregorian|hijri)(?:&|$)/.exec(search || '')
  if (preview) return pinned(preview[1])
  if (config.force === false) return null
  if (config.force) return pinned(config.force)
  var names = ['gregorian', 'hijri']
  for (var i = 0; i < names.length; i++) {
    if (config[names[i]].enabled) {
      var season = inWindow(names[i])
      if (season) return season
    }
  }
  return null
}
